import {
  Box,
  Typography,
  TextField,
  Divider,
  MenuItem,
  Select
} from '@mui/material';
import { useState, useEffect } from 'react';

const expenseRows = [
  'STAMP','REGISTRATION','CD','COMPUTER','LISION',
  'REFERENCE','FIELD INSP AMOUNT','PETROL','FOOD',
  'STATIONARY','EC'
];

const docTypes = [
    'Type of Document',
  'SALE','MOD','RECEIPT','PARTITION',
  'PARTITION RELEASE DEED','LEASE',
  'SETTLEMENT','SIMPLE MORTGAGE','POWER'
];

const paymentStatusList = ['RECEIVED', 'PENDING', 'NA'];
const paidStatusList = ['PAID', 'UNPAID', 'NA'];

const RegistrationForm = ({ onChange, user, initialData }) => {

  const [form, setForm] = useState({
    meta: {
      employee_name: user?.name || '',
      emp_id: user?.id || '',
      date: new Date().toLocaleDateString()
    },
    category: 'REGISTRATION',
    registration_status: 'PENDING',

    customer: {
      name: '',
      mobile: '',
      reference: '',
      received_amount: 0,
      doc_type: '',
      bank: '',
      sro: '',
      advocate_fees: 0
    },
    rows: []
  });

  useEffect(() => {
      if (initialData) {
        setForm(prev => ({
            ...prev,
            ...initialData,
            customer: {
            ...prev.customer,
            ...(initialData?.customer || {})
            },
            rows: initialData?.rows || prev.rows,
            meta: {
            ...prev.meta,
            ...(initialData?.meta || {})
            }
        }));
      } else {
          setForm(prev => ({
              ...prev,
              customer: {
                  ...prev.customer,
                  doc_type: 'Type of Document'   // 🔥 only for new records
              },
              rows: expenseRows.map(r => ({
                  label: r,
                  amount: '',
                  payment_status: 'PENDING',
                  paid_status: 'NA'
              }))
          }));
      }
  }, [initialData]);

  useEffect(() => {
    const balance =
      Number(form.customer.received_amount || 0) -
      form.rows.reduce((s, r) => s + Number(r.amount || 0), 0);

    onChange({
      ...form,
      balance
    });

  }, [form]);

  const updateCustomer = (key, val) => {
    setForm({
      ...form,
      customer: { ...form.customer, [key]: val }
    });
  };

  const updateRow = (i, key, val) => {
    const copy = [...form.rows];
    copy[i][key] = val;
    setForm({ ...form, rows: copy });
  };

  const balance =
    Number(form.customer.received_amount || 0) -
    form.rows.reduce((s, r) => s + Number(r.amount || 0), 0);

  return (
    <Box>

      {/* 🔥 HEADER SECTION */}
      <Typography align="center" fontWeight={600} mb={2}>
        Registration Expenses
      </Typography>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '2fr 1fr 1fr',
          gap: 2,
          mb: 2
        }}
      >
        <TextField label="Employee Name" value={form.meta.employee_name} disabled />
        <TextField label="Employee ID" value={form.meta.emp_id} disabled />
        <TextField label="Date" value={form.meta.date} disabled />
      </Box>

      {/* 🔥 CATEGORY + STATUS */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '2fr 1fr',
          gap: 2,
          mb: 2
        }}
      >
        <TextField label="Category" value="Registration" disabled />

        <Select
          value={form.registration_status}
          onChange={(e) =>
            setForm({ ...form, registration_status: e.target.value })
          }
        >
          <MenuItem value="COMPLETED">Completed</MenuItem>
          <MenuItem value="PENDING">Pending</MenuItem>
        </Select>
      </Box>

      <Divider sx={{ mb: 2 }} />

      {/* 🔥 CUSTOMER DETAILS */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: 2,
          mb: 2
        }}
      >
        <TextField label="Customer Name"
          value={form.customer.name}
          onChange={(e) => updateCustomer('name', e.target.value)}
        />

        <TextField label="Mobile"
          value={form.customer.mobile}
          onChange={(e) => updateCustomer('mobile', e.target.value)}
        />

        <TextField label="Reference Staff"
          value={form.customer.reference}
          onChange={(e) => updateCustomer('reference', e.target.value)}
        />

        <TextField label="Received Amount"
          type="number"
          value={form.customer.received_amount}
          onChange={(e) => updateCustomer('received_amount', e.target.value)}
        />

        <Select
          value={form.customer.doc_type}
          onChange={(e) => updateCustomer('doc_type', e.target.value)}
        >
          {docTypes.map(d => <MenuItem key={d} value={d}>{d}</MenuItem>)}
        </Select>

        <TextField label="Bank"
          value={form.customer.bank}
          onChange={(e) => updateCustomer('bank', e.target.value)}
        />

        <TextField label="SRO"
          value={form.customer.sro}
          onChange={(e) => updateCustomer('sro', e.target.value)}
        />

        <TextField label="Advocate Fees"
          type="number"
          value={form.customer.advocate_fees}
          onChange={(e) => updateCustomer('advocate_fees', e.target.value)}
        />
      </Box>

      <Divider sx={{ mb: 2 }} />

      {/* 🔥 GRID HEADER */}
          <Box
              sx={{
                  display: 'grid',
                  gridTemplateColumns: '2fr 2fr 2fr 2fr',
                  px: 2,
                  py: 1.5,
                  background: '#f4f6f8',
                  borderBottom: '2px solid #ddd'
              }}
          >
              {['Description', 'Amount', 'Payment Status', 'Paid / Unpaid'].map((h) => (
                  <Box
                      key={h}
                      sx={{
                          display: 'flex',
                          alignItems: 'center',      // 🔥 vertical center
                          justifyContent: 'center',  // 🔥 horizontal center
                          fontWeight: 600,
                          color: '#374151'
                      }}
                  >
                      {h}
                  </Box>
              ))}
          </Box>

      {/* 🔥 ROWS */}
      {
      (initialData
        ? form.rows.filter((row) => Number(row.amount || 0) > 0)
        : form.rows
      ).map((row, i) => (
        <Box key={i} sx={{
          display: 'grid',
          gridTemplateColumns: '2fr 2fr 2fr 2fr',
          gap: 1,
          px: 2,
          py: 1.5,
          borderBottom: '1px solid #eee'
        }}>
          <Typography
            sx={{
                display: 'flex',
                alignItems: 'center',
                height: '100%'   // ensures perfect vertical match
            }}
            >
            {row.label}
            </Typography>

          <TextField
            variant="standard"
            type="number"
            value={row.amount}
            onChange={(e) => updateRow(i, 'amount', e.target.value)}
            inputProps={{ style: { textAlign: 'right' } }}
          />

          <Select
            value={row.payment_status}
            onChange={(e) => updateRow(i, 'payment_status', e.target.value)}
          >
            {paymentStatusList.map(p => (
              <MenuItem key={p} value={p}>{p}</MenuItem>
            ))}
          </Select>

          <Select
            value={row.paid_status}
            onChange={(e) => updateRow(i, 'paid_status', e.target.value)}
          >
            {paidStatusList.map(p => (
              <MenuItem key={p} value={p}>{p}</MenuItem>
            ))}
          </Select>
        </Box>
      ))}

      {/* 🔥 BALANCE ONLY */}
      <Box sx={{
        display: 'flex',
        justifyContent: 'space-between',
        px: 2,
        py: 2,
        mt: 2,
        background: '#fef3c7',
        borderRadius: 2
      }}>
        <Typography fontWeight={600}>Balance</Typography>
        <Typography fontWeight={600}>₹ {balance}</Typography>
      </Box>

    </Box>
  );
};

export default RegistrationForm;